export * from './analitics';
export * from './armatuEquipoUrls';
export * from './compareDateIsOlder';
export * from './containerTemplate';
export * from './currenciesBonds';
export * from './cryptoHash';
export * from './formatDate';
export * from './formatRelativeLiveblog';
export * from './formatNews';
export * from './formatText';
export * from './games';
export * from './getBuckets';
export * from './getCookie';
export * from './getDataComments';
export * from './getFromRelated';
export * from './getImageByClippings';
export * from './getLatest';
export * from './getPath'
export * from './getPostElection'
export * from './getPriceRural'
export * from './getStringWithoutHtml';
export * from './getStringWithoutAcute';
export * from './getSuscriptionPrice';
export * from './getZodiac';
export * from './login';
export * from './newsletter';
export * from './notifications';
export * from './service';
export * from './socialNetworking';
export * from './weather';
export * from './weatherRural';
export * from './getPostElection';
export * from './generatePDF';
export * from './getVideoLoopUrl';
//export * from './newsContex';
export * from './encryptData';
export * from './getCompatibilityBetweenSigns';
export * from './mamTicker'
export * from './video';
export * from './getDataAgenda';
export * from './getMatchLocalDate';
export * from './llaveCopa';
export * from './filterDataAgendaLila';
export * from './lilaxService';
export * from './locales';
export * from './getWidgetListData';